import { Component, type ReactNode } from 'react';

/** Stops a render error from white-screening the whole app. */
export default class ErrorBoundary extends Component<{ children: ReactNode }, { err: Error | null }> {
  state = { err: null as Error | null };
  static getDerivedStateFromError(err: Error) { return { err }; }
  componentDidCatch(err: Error) { console.error('UI crash:', err); }

  render() {
    if (!this.state.err) return this.props.children;
    return (
      <div className="app pad center">
        <div style={{ fontSize: 44 }}>⚠️</div>
        <h1>Something went wrong</h1>
        <p className="muted">The screen hit an error. Reloading usually fixes it.</p>
        <button onClick={() => location.reload()}>Reload</button>
        <button className="secondary" onClick={() => { location.href = '/'; }}>Go to start</button>
        <p className="tiny muted" style={{ marginTop: 16 }}>{String(this.state.err?.message ?? '')}</p>
      </div>
    );
  }
}
